export default __webpack_public_path__ + "static/media/about-watch.9106c1fe.jpg";